import { Controller as BaseController } from 'stimulus'
import { useDispatch } from 'stimulus-use'
import get from 'lodash/get'

import './index.scss'
import { useCollapser } from '@app/javascript/controllers/mixins/useCollapser'

export class Controller extends BaseController {
  static targets = ['self', 'collapsable']

  static values = {
    collapserControllerId: String
  }

  _disableScrollAnchorCSSKlass = 'h-overflow-anchor-none';

  _defaultCollapserControllerId = 'collapsible-entity-chunk';

  initialize() {
    useCollapser(this)
  }

  connect() {
    useDispatch(this)

    this._locked = false

    // --------------------------------------------------------------------------
    //  This is needed to avoid a bug causing users not to be able scroll down.
    //  Check IRIS-1056 Jira ticket for more info.
    if (this.hasCollapsableTarget) {
      this._extraPadding = this.collapsableTarget.offsetHeight * 1.5
    }

    // Disable scroll anchoring.
    const body = document.body

    if (!body.classList.contains(this._disableScrollAnchorCSSKlass)) {
      body.classList.add(this._disableScrollAnchorCSSKlass)
    }
    // --------------------------------------------------------------------------
    if ($(this.selfTarget).parents('.flyout__container').length) {
      this._scrollableElement = this.selfTarget.parentElement.parentElement.parentElement
    } else {
      const scrollElem = document.querySelector('[data-atomic--organism--entity-page-header-target="scrollContainer"]')
      if (scrollElem) {
        // Doing it this way since the scrollContainer is not a child of the header
        this._scrollableElement = scrollElem
      } else {
        // Used for Issues show pages
        this._scrollableElement = window
      }
    }

    this._scrollableElement.addEventListener('scroll', this.runOnScroll.bind(this))
  }

  disconnect() {
    this._scrollableElement.removeEventListener('scroll', this.runOnScroll.bind(this))
  }

  runOnScroll() {
    if (this._locked) {
      return
    }
    this._locked = true
    this.scrollHandler()
    setTimeout(() => {
      this._locked = false
    }, 0)
  }

  scrollHandler() {
    const overviewMenu = $('#overview-menu')[0]
    const overviewMenuChevron = $('#overview-menu-chevron')[0]
    if (overviewMenu && overviewMenuChevron) {
      overviewMenu.classList.add('hidden')
      overviewMenuChevron.classList.remove('h-transform-rotate-180')
    }
    const lastKnownScrollPosition = this._scrollableElement.scrollY || this._scrollableElement.scrollTop || 0
    const content = this.selfTarget.querySelector(`[data-controller*='${this.collapserControllerId}']`)?.[this.collapserControllerId]

    if (lastKnownScrollPosition < 50 && content?.isCollapsed()) {
      content?.expand()
      this.expand()

      this.dispatch('expanded')

      return
    }

    const elementMaxHeight = $(get(this.selfTarget, 'children[0]')).height()
    if (!content?.isCollapsed() && lastKnownScrollPosition > elementMaxHeight) {
      content?.collapse()
      this.collapse()

      this.dispatch('collapsed')
    }
  }

  // PRIVATE
  get collapserControllerId() {
    if (this.hasCollapserControllerIdValue) {
      return this.collapserControllerIdValue
    }
    return this._defaultCollapserControllerId
  }
}
